import React, { Component } from 'react';
import { Modal, Button, Row, Col, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';
import _ from 'lodash';
import { JSEncrypt } from 'jsencrypt';
import Picky from 'react-picky';
import ProcessWise from './ProcessWise';
import 'react-picky/dist/picky.css'; // Include CSS
export default class AddUser extends Component {  
   constructor(props, context) {
        super(props, context);    
        this.state = {
          employeeId:'',
          firstName: '',
          lastName: '',
          password: '',
          supervisorUsersName:  '',
          email: '',
          mobileNumber: '', 
          status:  'NEW',
          selectedregionName: [],
          selectedcenterName:  [],
          selectedclientName: [],
          selectedprocessName: [],
          selectedrole: [],
          selectedCategory: [],
          selectedReports: [],
          selectedSupervisor:[],
          passwordtype:"password",
          emailIsValid:true,
          passwordIsValid:true,
        }
      this.bulkclientName=[]
    };
     
    handleSubmit =() => {   
       const{employeeId, firstName, password, selectedSupervisor, email, mobileNumber, selectedregionName, lastName, status,
        selectedcenterName, selectedclientName, selectedprocessName, selectedrole, selectedReports, selectedCategory} = this.state;
        let cloneDeepRegion = _.cloneDeep(selectedregionName);  
        let returnObj = [];
        _.map(cloneDeepRegion, (x) => {
          let centers =[]
          _.map(x.centers, (y) =>{
            let obj = _.find(selectedcenterName, {'inventoryCenterId':y.inventoryCenterId})
            if(typeof obj !== 'undefined'){
              centers.push({'inventoryCenterId':obj.inventoryCenterId, 'inventoryCenterName':obj.inventoryCenterName, userClients:[]})
            }    
            _.map(y.clients, (z) =>{
              let obj1 = _.find(selectedclientName, {'inventoryClientId':z.inventoryClientId})
              if(typeof obj1 !== 'undefined'){
                let newclients = _.find(centers, {'inventoryCenterId':y.inventoryCenterId})
                if(typeof  newclients !== 'undefined' && _.isArray(newclients.userClients)){
                  newclients.userClients.push({'inventoryClientId':obj1.inventoryClientId, 'inventoryClientName':obj1.inventoryClientName, userProcesses:[]})
                }
              }
              _.map(z.processes, (z1) =>{
                  let obj2 = _.find(selectedprocessName, {'inventoryProcessId':z1.inventoryProcessId})
                  if(typeof obj2 !== 'undefined'){
                    let abc = _.find(centers, {'inventoryCenterId':y.inventoryCenterId})
                    if(typeof abc !== 'undefined' && typeof abc.userClients !== 'undefined'){
                        let abc1 = _.find(abc.userClients, {'inventoryClientId':z.inventoryClientId})
                        if(typeof abc1 !== 'undefined' && _.isArray(abc1.userProcesses)){
                          abc1.userProcesses.push(obj2)
                        }
                    }
                  }
              }) 
            })
          })
          let returnvalues  =  {'inventoryRegionId':x.inventoryRegionId, 'inventoryRegionName':x.inventoryRegionName,
          "userCenters":centers }
          if(!_.isNull(returnvalues)) {
            returnObj.push(returnvalues)
          }
        })
        const publickey = process.env.REACT_APP_PUBLIC_KEY;
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publickey);
        const encyPassword = encrypt.encrypt(password);
        let new_user={
          "email" : email,
          "firstName" : firstName,
          "lastName" : lastName,
          "employeeId" : employeeId,
          "mobileNumber" : mobileNumber,
          "roleId" : selectedrole ? selectedrole.roleId : null,
          "rolesName" : selectedrole ? selectedrole.rolesName : null,
          "userInventoryMaps" : returnObj,
          "reports" : selectedReports,
          "password" : encyPassword,
          "supervisorUsersId" : selectedSupervisor? selectedSupervisor.supervisorUsersId : null,
          "supervisorUsersName" : selectedSupervisor ? selectedSupervisor.supervisorUsersName : null,
          "inventoryCategoryId" : selectedCategory ? selectedCategory.id : null,
          "inventoryCategoryName" : selectedCategory ? selectedCategory.label : null,
          "status": status,
        }
        
        this.props.action.addnewUser(new_user) 
        this.setState({          
          show: false,
          employeeId:'',
          firstName:'',
          password:'',
          supervisorUsersName:'',
          email:'',
          mobileNumber:'',
					roles:'',  
          status:'ACTIVE',
          selectedregionName:[],
          selectedcenterName:[],
          selectedclientName:[],
          selectedprocessName:[],
          selectedTemplate:[],
          selectedrole:[],
          selectedCategory:[]
        })
        this.props.closeModal()
		}
		addroles = () =>{
			const{inventory} = this.props;			
			let regionUI = _.map(inventory.roles, (obj)=>{
				return(<option id='roles' value={obj.label}>{obj.label}</option>)
			})
			return regionUI;
    }
    addagentCategory = () => {
      const{inventory} = this.props;			
			let regionUI = _.map(inventory.agentCatgories, (obj)=>{
				return(<option id='agentCategory' value={obj.label}>{obj.label}</option>)
			})
			return regionUI;

    }
		addregions = () =>{
      const{inventory} = this.props;
      if(!_.isEmpty(inventory)){
      let regionNames = inventory 
      return regionNames;
      }
		}
		addcenters = () => {
      const{selectedregionName} = this.state;
      const{inventory} = this.props;
      let centerName=[];
      if(!_.isEmpty(inventory) && !_.isEmpty(selectedregionName)){
        _.map(selectedregionName, (obj)=>{
          let x = _.filter(obj.centers);
          centerName.push(...x );
          centerName = _.uniqBy(centerName, 'inventoryCenterId');          
       })
       return centerName;
        
      }
		}
		addclients= () => {
      const{selectedcenterName} = this.state;
      const{inventory} = this.props;
      let clientName=[];
      if(!_.isEmpty(inventory) && !_.isEmpty(selectedcenterName)){
       _.map(selectedcenterName, (obj)=>{
         let x = _.filter(obj.clients);
         clientName.push(...x);
         this.bulkclientName=clientName       
       }) 
      return  _.uniqBy(clientName, 'inventoryClientId');
      }
    }
    processNames = () => {
      const{selectedclientName} = this.state;
      const{inventory} = this.props;
      let processName=[];
      if(!_.isEmpty(inventory)){
      _.map(selectedclientName, (obj)=>{
          let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processName.push(...z.processes)
            processName = _.uniqBy(processName, 'inventoryProcessId');
          })
          
      }) 
       return processName;
      }
    }		
    handleChange = event => {      
      this.setState({
      [event.target.id]: event.target.value
      });
    }
    handleSelect = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedregionName: e} );
      if(!_.isEqual(this.state.selectedregionName, e)){    
        this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
      }
    }
    handleSelectCenter = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedcenterName: e});
      if(!_.isEqual(this.state.selectedcenterName, e)){               
        this.setState({selectedclientName:[], selectedprocessName:[]})
      }
    }
    handleSelectClient = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedclientName: e});
      if(!_.isEqual(this.state.selectedclientName, e)){
        this.setState({selectedprocessName:[]})
      }
    }
    handleSelectProcess = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedprocessName: e});
    }
    handleSelectRoles = (e) => {
      this.setState({selectedrole: e});
      if(!_.isEqual(this.state.selectedrole, e)){    
        this.setState({selectedregionName:[], selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
      }
    }
    handleSelectCategory = (e) => {
      this.setState({selectedCategory: e});
    }
    handleSelectReports = (e) => {
      this.setState({selectedReports: e});
    }
    handleSelectSupervisor = (e) => {
      this.setState({selectedSupervisor: e});
    }
    chooseModal =() =>{
      this.setState({showModal:true})
    }
    chooseModalClose =() =>{
      this.setState({showModal:false})
    }
    validateForm() {
      if(this.state.employeeId && this.state.employeeId.length > 0 && this.state.password  &&
        this.state.password.length > 5 && this.state.firstName && this.state.firstName.length > 0 && this.state.emailIsValid && this.state.passwordIsValid &&
        this.state.lastName && this.state.lastName.length > 0 && this.state.email && this.state.email.length > 0 && !_.isEmpty(this.state.selectedrole)
        && !_.isEmpty(this.state.selectedregionName) && !_.isEmpty(this.state.selectedcenterName) && !_.isEmpty(this.state.selectedclientName) && !_.isEmpty(this.state.selectedprocessName) 
      ){
        if(this.state.selectedrole && this.state.selectedrole.rolesName === 'Agent'){
          let Category = false
          _.map(this.state.selectedprocessName, (obj) => {
            if(_.has(obj,'inventoryCategoryId') && !_.isNull(obj.inventoryCategoryId)){
              Category = true
            } else {
              Category = false
            }
          })
          
          if(!_.isEmpty(this.state.selectedSupervisor) && Category === true){
            return true
          }
        } else {
          return true
        }        
      }      
    }
    handleProcessCategories = (obj) =>{
      this.setState({selectedprocessName:[obj]})
    }
    viewPassword = (prop) => {
     this.setState({passwordtype:prop}) 
    }
    isValidEmailAddress = (address) =>{
      if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)){
        return true
      } else {
        return false
      }
    }
    isValidPassword = (password) =>{
      if(password.length>5){
        return true
      } else {
        return false
      }
    }
    render(){  
        return(         
            <Modal
            show={true}
            onHide={this.props.closeModal}
            dialogClassName="modal-120w"
						//aria-labelledby="example-custom-modal-styling-title"
            size="xl"
            backdrop='static'                  
            keyboard={false}
            aria-labelledby="contained-modal-title-vcenter"
						centered
            >
            <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
            ADD USER
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
						<form>
            <span className="RedColoring">* indicates required field</span>
            <div className="clearBoth">
            <Row>           
							<Col>
            <FormGroup controlId="employeeId" >
                <FormLabel>User ID<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user"/></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="employeeId"
                    value={this.state.employeeId}
                    onChange={this.handleChange}
                    maxLength="30" 
                    minLength="3"
                /></InputGroup>
            </FormGroup>
            <FormGroup controlId="firstName" >
                <FormLabel>Name<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="firstName"
                    value={this.state.firstName}
                    onChange={this.handleChange}
                    minLength="3"
                    maxLength="50" 
                /></InputGroup>
            </FormGroup>
            <FormGroup>
            <FormLabel>Supervisor
            {this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ?
              <span className="RedColoring"> *</span> : null : null}
            </FormLabel>             
            <Picky keepOpen={false}
            value={this.state.selectedSupervisor}
            options={this.props.supervisorData}
            onChange={this.handleSelectSupervisor}
            open={false}
            valueKey="supervisorUsersName"
            labelKey="supervisorUsersName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Supervisor'
            dropdownHeight={600}
          />
          {!_.isEmpty(this.state.selectedSupervisor) ? <h6>{this.state.selectedSupervisor.supervisorUsersId}</h6> : null}         
          </FormGroup>
            <FormGroup >
            <FormLabel>Region <span className="RedColoring"> *</span></FormLabel> 
            <Picky keepOpen={false}
            value={this.state.selectedregionName}
            options={this.addregions()}
            onChange={this.handleSelect}
            open={false}
            valueKey="inventoryRegionName"
            labelKey="inventoryRegionName"
            multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
            includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Region'
            dropdownHeight={600}
          />            
          </FormGroup>             					
					<FormGroup >
            <FormLabel>Process <span className="RedColoring"> *</span></FormLabel> 
        {(!_.isEmpty(this.state.selectedrole) &&  this.state.selectedrole.rolesName === 'Agent') ?
        <div>
          <p onClick={()=>this.chooseModal()}> Click To Select Process and Agent Category</p>
           {this.state.showModal ?
            <ProcessWise 
              callBack={(a)=>this.handleProcessCategories(a)}
              categories = {this.props.categoryData}
              selectedprocessName={_.cloneDeep(this.state.selectedprocessName)}
              process={this.processNames()}
              handleClose={this.chooseModalClose}/>
            : null }
            </div>
            : 
            <Picky keepOpen={false}
              value={this.state.selectedprocessName}
              options={this.processNames()}
              onChange={this.handleSelectProcess}
              open={false}
              valueKey="inventoryProcessName"
              labelKey="inventoryProcessName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Process Name'
              dropdownHeight={600}
           /> }
          </FormGroup> 
         
            </Col>
            <Col>
            <FormGroup controlId="password" >
                <FormLabel>Password<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-lock"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type={this.state.passwordtype}
                    value={this.state.password}
                    onBlur={() => this.setState({
                      passwordIsValid: this.isValidPassword(this.state.password)
                    }) }
                    onChange={this.handleChange}      
                    maxLength="40"              
                /><InputGroup.Append>
                  <InputGroup.Text id="basic-addon2">{this.state.passwordtype === "password" ?     
                    <i class='fas fa-eye' onClick={()=>this.viewPassword('text')} /> :
                    <i class='fas fa-eye-slash' onClick={()=>this.viewPassword('password')} /> }</InputGroup.Text>
                  </InputGroup.Append>
                  </InputGroup>
                  {(this.state.passwordIsValid === false) ? <span className="RedColoring">&nbsp;**Minimum 6 characters**</span>: null}
            </FormGroup>  
            <FormGroup controlId="lastName" >
                <FormLabel>Last Name<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="lastName"
                    value={this.state.lastName}
                    onChange={this.handleChange}
                    maxLength="50"
                /></InputGroup>
            </FormGroup>
            <FormGroup>
            <FormLabel>Role<span className="RedColoring"> *</span></FormLabel> 
            <Picky keepOpen={false}
            value={this.state.selectedrole}
            options={this.props.rolesData}
            onChange={this.handleSelectRoles}
            open={false}
            valueKey="rolesName"
            labelKey="rolesName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Roles'
            dropdownHeight={600}
          />
          </FormGroup>
          <FormGroup >
              <FormLabel>Center<span className="RedColoring"> *</span></FormLabel> 
              <Picky keepOpen={false}
              value={this.state.selectedcenterName}
              options={this.addcenters()}
              onChange={this.handleSelectCenter}
              open={false}
              valueKey="inventoryCenterName"
              labelKey="inventoryCenterName"
              multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Center'
              dropdownHeight={600}
            />
             </FormGroup>
           
             </Col>
						<Col> 	
            <FormGroup controlId="mobileNumber" >
                <FormLabel>Mobile Number</FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-mobile-alt"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="mobileNumber"
                    value={this.state.mobileNumber}
                    onChange={this.handleChange}
                /></InputGroup>
            </FormGroup>
            <FormGroup controlId="email" >
                <FormLabel>Email<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-envelope"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="email"
                    onBlur={() => this.setState({
                      emailIsValid: this.isValidEmailAddress(this.state.email)
                    }) }
                    value={this.state.email}
                    maxLength="100" 
                    onChange={this.handleChange}
                /></InputGroup>
                 {(this.state.emailIsValid === false) ? <span className="RedColoring">&nbsp;****Enter valid email****</span>: null}
            </FormGroup>
            <FormGroup >
            <FormLabel> Reports</FormLabel> 
						<Picky keepOpen={false}
              value={this.state.selectedReports}
              options={this.props.reportlist}
              onChange={this.handleSelectReports}
              open={false}
              valueKey="reportName"
              labelKey="reportName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Reports'
              dropdownHeight={600}
            />
          </FormGroup> 
            
          <FormGroup >
              <FormLabel>Client <span className="RedColoring"> *</span></FormLabel> 
              <Picky keepOpen={false}
                value={this.state.selectedclientName}
                options={this.addclients()}
                onChange={this.handleSelectClient}
                open={false}
                valueKey="inventoryClientName"
                labelKey="inventoryClientName"
                multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
                includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
                includeFilter={true}
                clearFilterOnClose={true}
                placeholder='Select Client'
                dropdownHeight={600}
              />
            </FormGroup>     
          
                  
            </Col>
            </Row>
            <Row>
              <Col>              
						<Button
            block
            className=''          
            type="button"
            onClick={this.handleSubmit}
            disabled={!this.validateForm()}
            > <b>{"Add User"}</b>
            </Button></Col>        
            </Row>
            </div>
          	</form>
            </Modal.Body>
            </Modal>
        
        );
    }
}
